import script from "./LotoAreaSelect.vue?vue&type=script&lang=ts&setup=true"
export * from "./LotoAreaSelect.vue?vue&type=script&lang=ts&setup=true"

import "./LotoAreaSelect.vue?vue&type=style&index=0&id=adb60250&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-adb60250"]])

export default __exports__